enum ContractAuthenticationDetailStatus {
  COMPLETED = 'authentication.completed',
  FAILED = 'authentication.failed',
  FAILURE_CANCEL = 'authentication.failure.cancel',
  FAILURE_GUIDE_CHECK = 'authentication.failure.guide.check',
  FAILURE_SERVER = 'authentication.failure.server',
  PROCESSING = 'authentication.processing',
  READY = 'authentication.ready',
}

export default ContractAuthenticationDetailStatus;
